import { styled } from 'styled-components'

import { FormattedMessage } from '@b-stock/fe-core/bstock-react'

import { WatchlistUndoButton as UndoButton } from './WatchlistUndoButton'

const ToastContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
`

/**
 * Toast content component for watchlist removal notifications
 *
 * Features:
 * - Shows message when item is removed from watchlist; with `hasKeptNote`
 *   (`notes-outlive-watchlist` on and the listing has a note) it says the
 *   note stays with the listing
 * - Optional Undo action, shown when `onUndo` is provided
 * - Close button handled by react-toastify configuration
 */
const WatchlistRemovalToastContent = ({
  hasKeptNote = false,
  onUndo,
}: {
  hasKeptNote?: boolean
  onUndo?: () => void
} = {}) => {
  return (
    <ToastContainer>
      <span>
        {hasKeptNote ? (
          <FormattedMessage id="Listing.watchlist.removeToastTextNoteKept" />
        ) : (
          <FormattedMessage id="Listing.watchlist.removeToastText" />
        )}
      </span>
      {onUndo && (
        <UndoButton type="button" onClick={onUndo}>
          <FormattedMessage id="Listing.watchlist.undoButtonLabel" />
        </UndoButton>
      )}
    </ToastContainer>
  )
}

export default WatchlistRemovalToastContent
